<template>
  <v-chart :option="option" autoresize style="width:100%;height:100%;" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VChart from 'vue-echarts';
import { useChartTheme } from '@/composables/useChartTheme';

const props = defineProps<{ values: number[] }>();

const option = computed(() => {
  const C = useChartTheme();
  return {
    backgroundColor: 'transparent',
    grid: { top: 4, bottom: 4, left: 2, right: 2 },
    xAxis: {
      type: 'category',
      show: false,
      boundaryGap: false,
      data: props.values.map((_, i) => String(i + 1)),
    },
    yAxis: { type: 'value', show: false },
    series: [{
      type: 'bar',
      data: props.values,
      barWidth: '60%',
      itemStyle: { color: C.accent, borderRadius: [2, 2, 0, 0] },
    }],
  };
});
</script>
